import { chipCompoundVariants, chipDisabledVariants, chipElevatedVariants, chipEmphasisVariants, inputChipDefaultVariants, inputChipSizeVariants, inputChipSlots } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const commonVariants = {
    disabled: chipDisabledVariants,
    elevated: chipElevatedVariants,
    emphasis: chipEmphasisVariants
};
const inputChipVariants = tv({
    slots: inputChipSlots,
    variants: {
        size: inputChipSizeVariants,
        ...commonVariants
    },
    compoundVariants: [
        ...chipCompoundVariants,
        {
            elevated: true,
            className: {
                containerSlot: 'hover:aria-pressed:shadow-none'
            }
        },
        {
            emphasis: [
                'regular',
                'medium',
                'bold'
            ],
            className: {
                containerSlot: 'hover:aria-pressed:shadow-none'
            }
        }
    ],
    defaultVariants: inputChipDefaultVariants
});
export { inputChipVariants };
